import xamatron from "xamatron";
var Blinkenlights = /** @class */ (function () {
    function Blinkenlights() {
    }
    Blinkenlights.prototype.set = function (rgb) {
        if (xamatron.enabled)
            xamatron.bridge.post("Avenla.OfficeTools.SetLight", rgb);
    };
    return Blinkenlights;
}());
export default new Blinkenlights();



//////////////////
// WEBPACK FOOTER
// ./app/ts/blinkenlights.ts
// module id = 171
// module chunks = 0